import React from 'react';
import { classes, style } from 'typestyle';
// import * as React from 'react';
import { rebrand } from '../../../theme/color';
import { Link, LinkProps } from './Link';
import { BackgroundProps } from '../utilities/props';
import { overlayLink } from '../../../theme/mixin';
import { AnalyticsContextProvider } from '../utilities/AnalyticsContext';
import { SubscriptionLabel } from './SubscriptionLabel';
import { zLabel } from '../../../theme/z';
import { borderRadius } from '../../../theme/border';
import { spacing } from '../../../theme/spacing';
import { NewLabel } from './NewLabel';
import { ClockUnion } from './icons/ClockUnion';
import { MusicNote } from './icons/MusicNote';

const styles = {
  tile: style({
    position: 'relative',
    $nest: {
      '&:hover .grid-tile-item-image, &:focus-within .grid-tile-item-image': {
        transform: 'scale(1.05) rotate(-1deg)',
      },
    },
  }),
  imageWrapper: style({
    position: 'relative',
    borderRadius: borderRadius.MEDIUM,
    overflow: 'hidden',
    width: '100%',
    paddingBottom: '100%',
  }),
  image: style({
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: `transform 300ms ease-in-out`,
    $nest: {
      '&:hover': {
        transform: 'scale(1.05)',
      },
    },
  }),
  textWrapper: style({
    textAlign: 'center',
    marginTop: spacing.XSMALL,
  }),
  link: style(overlayLink, {
    display: 'block',
    $nest: {
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),
  heading: style({
    display: 'block',
    fontWeight: 700,
  }),
  catalogueType: style({
    color: rebrand.contrast[40].toHexString(),
  }),
  favBtn: style({ $nest: { '& > *': { zIndex: zLabel } } }),
};

export type GridTileListItemProps = LinkProps &
  BackgroundProps & {
    heading: string;
    isPlaylist?: boolean;
    included?: boolean;
    is_newly_created?: boolean;
    is_recently_updated?: boolean;
  };

export const GridTileListItem: React.FC<GridTileListItemProps> = ({
  heading,
  className,
  children,
  src,
  gradient,
  included,
  isPlaylist,
  is_newly_created = false,
  is_recently_updated = false,
  ...props
}) => {
  const renderNewLabel = () => {
    if (is_newly_created) {
      return <NewLabel icon={<ClockUnion />} text={'Just added'} width={89} />;
    }

    if (is_recently_updated) {
      return <NewLabel icon={<MusicNote />} text={'Recently updated'} width={121} />;
    }

    return null;
  };

  return (
    <AnalyticsContextProvider context={{ gridTileHeading: heading }}>
      <li className={classes(styles.tile, className)}>
        <div className={styles.imageWrapper}>
          <img
            src={src}
            alt={`Artwork for ${heading}`}
            className={classes(styles.image, 'grid-tile-item-image')}
            loading="lazy"
          />
          <SubscriptionLabel included={included} />
          <span className={styles.favBtn}>{children}</span>
          {isPlaylist && renderNewLabel()}
        </div>

        <div className={styles.textWrapper}>
          <Link className={styles.link} {...props}>
            <span className={styles.heading}>{heading}</span>
          </Link>

          {isPlaylist && <span className={styles.catalogueType}>{included ? 'Included' : 'Premium'} playlist</span>}
        </div>
      </li>
    </AnalyticsContextProvider>
  );
};
